export const uiSchema = t => {
  return {
    advisorType: {
      "ui:widget": "hidden",
    },
    standardQuestion: {
      id: {
        "ui:options": {
          label: t("STANDARD_QUESTION_DETAILS_QUESTION_TYPE"),
        },
      },
    },
    isActive: {
      "ui:widget": "toggle",
      "ui:options": {
        tooltip: {
          description: t("IS_ACTIVE_TOOLTIP"),
          id: "is-active-tooltip",
          size: "medium",
        },
        label: t("STATUS"),
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
      },
    },
  };
};
